<ng-container *ngIf="options.schemaVersion === 'v34'">
    <cv-schema-render-room34-layout [class]="options.schemaVersion" [data]="data" [layoutNode]="layoutNode"></cv-schema-render-room34-layout>
</ng-container>
<ng-container *ngIf="options.schemaVersion === 'v40'">
    <cv-schema-render-room40-layout [class]="options.schemaVersion" [data]="data" [layoutNode]="layoutNode"></cv-schema-render-room40-layout>
</ng-container>
